// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__+H-QI","text":"Chip_text__xvUV9","iconWrap":"Chip_iconWrap__QTHBt"};